export default {"src":"/_next/static/media/banner-bab.441145c4.svg","height":48,"width":74,"blurWidth":0,"blurHeight":0};